module.exports = __webpack_public_path__ + "static/img/news1.971c216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news1/news1.png
// module id = 93Xa
// module chunks = 1